import { useFeatureGate } from './use-feature-gate';

export const FeatureGatedVariant = {
  SHOW_ON_FLAG: 'SHOW_ON_FLAG',
  HIDE_ON_FLAG: 'HIDE_ON_FLAG',
} as const;

type InputProps = {
  variant: keyof typeof FeatureGatedVariant;
  flagName: string;
  loadingComponent?: React.ReactNode;
};

type Props = InputProps & {
  children: any;
};

export const FeatureFlagged = ({ variant, flagName, loadingComponent, children }: Props) => {
  const { isEnabled, isLoading } = useFeatureGate(flagName);

  if (isLoading && loadingComponent) {
    return loadingComponent;
  }

  const childrenVisible = variant === FeatureGatedVariant.SHOW_ON_FLAG ? isEnabled : !isEnabled;
  return childrenVisible ? children : null;
};
